import React from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface FilterSingleSelectOption {
  value: string;
  label: string;
}

interface FilterSingleSelectProps {
  options: readonly FilterSingleSelectOption[];
  value: string;
  onValueChange: (value: string) => void;
  placeholder: string;
  className?: string;
}

export const FilterSingleSelect: React.FC<FilterSingleSelectProps> = ({
  options,
  value,
  onValueChange,
  placeholder,
  className,
}) => {
  const selectedLabel =
    options.find((option) => option.value === value)?.label ?? placeholder;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button type="button" variant="new_outline" className={className}>
          <span className="truncate">{selectedLabel}</span>
          <ChevronDown />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className="min-w-[var(--radix-dropdown-menu-trigger-width)]"
      >
        <DropdownMenuRadioGroup value={value} onValueChange={onValueChange}>
          {options.map((option) => (
            <DropdownMenuRadioItem key={option.value} value={option.value}>
              {option.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
